define('modules/reporting/campaigns/siteTransparency/views/columnSelector',["T1ColumnSortable"], function (ColumnSortable) {
  "use strict";

  return ColumnSortable.extend({});
});
